<template>
    <ModalTheme :overlay="false" @close="closeModal" :loading="loading || parentLoading">
        <template slot="main">
            <h1 class="txtCenter" style="font-size: xx-large;">{{ isSsoSystemNew ? "Add a new SSO system" : "Edit SSO system" + ssoSystem.name }}</h1>
            <form enctype="multipart/form-data" @submit="validateForm" action="">
                <div class="validation-errors" v-if="validationErrors.length > 0">
                    <ul v-for="(error, index) in validationErrors" v-bind:key="index">
                        <li>{{ error }}</li>
                    </ul>
                </div>
                <div class="form-group row">
                    <label for="prop-name" class="col-4 col-form-label label">Name</label>
                    <div class="col-8"><input id="prop-name" class="full-width" type="text" v-model="ssoSystem.name" required /></div>
                </div>
                <div class="form-group row">
                    <label for="prop-name" class="col-4 col-form-label label">Type</label>
                    <div class="col-8">
                        <select class="full-width" v-model="ssoSystem.type.id" required>
                            <option v-for="type in availableTypes" :value="type.id" :selected="ssoSystem.type.id === type.id" v-bind:key="type.id">
                                {{ type.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="prop-configuration-1" class="col-4 col-form-label label">IDP Single Sign On Service Url</label>
                    <div class="col-8">
                        <input
                            id="prop-configuration-1"
                            class="full-width"
                            type="text"
                            required
                            v-model="ssoSystem.configuration.idpSingleSignOnServiceUrl"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="prop-configuration-2" class="col-4 col-form-label label">IDP Entity ID</label>
                    <div class="col-8">
                        <input id="prop-configuration-2" type="text" class="full-width" required v-model="ssoSystem.configuration.idpEntityId" />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="prop-configuration-3" class="col-4 col-form-label label">IDP Public Certificate</label>
                    <div class="col-8">
                        <textarea
                            id="prop-configuration-3"
                            type="text"
                            class="full-width"
                            rows="10"
                            required
                            v-model="ssoSystem.configuration.idpX509cert"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="prop-configuration-4" class="col-4 col-form-label label">SP Entity ID</label>
                    <div class="col-8">
                        <input
                            placeholder="will be generated automatically"
                            id="prop-configuration-4"
                            class="full-width"
                            type="text"
                            readonly
                            v-model="ssoSystem.configuration.spEntityId"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="prop-configuration-5" class="col-4 col-form-label label">SP Assertion Consumer Service URL</label>
                    <div class="col-8">
                        <input
                            placeholder="will be generated automatically"
                            id="prop-configuration-5"
                            class="full-width"
                            type="text"
                            readonly
                            v-model="ssoSystem.configuration.spAssertionConsumerServiceUrl"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="prop-configuration-6" class="col-4 col-form-label label">SP Single Logout Service URL</label>
                    <div class="col-8">
                        <input
                            placeholder="will be generated automatically"
                            id="prop-configuration-6"
                            class="full-width"
                            type="text"
                            readonly
                            v-model="ssoSystem.configuration.spSingleLogoutServiceUrl"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="prop-domains" class="col-4 col-form-label label">Domains covered</label>
                    <div class="col-8">
                        <ul>
                            <li v-for="domain in ssoSystem.domains" v-bind:key="domain.name" class="reduced-width">
                                &#64;{{ domain.name }}
                                <span class="roundedIcon pointer" @click="removeDomain(domain.name);"><i class="fas fa-trash-alt"></i></span>
                            </li>
                        </ul>
                        <input class="reduced-width" id="prop-domains" type="text" v-model="newDomain" />
                        <span class="roundedIcon pointer" @click="addDomain();"><i class="fas fa-plus-circle"></i></span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <input type="checkbox" v-model="ssoSystem.allowInternalAuth" />
                        <span class="label"> Allow internal authentication for some users within these domains</span>
                    </div>
                </div>
                <div class="flexContainer"><button class="btn block pointer uppercase save">save</button></div>
            </form>
        </template>
        <template v-if="false" slot="overlay"> </template> <template slot="footer"> </template>
    </ModalTheme>
</template>

<script>
import SsoSystemHttpService from "./SsoSystemHttpService";
import { SsoSystem, SSO_SYSTEM_TYPES } from "./SsoSystem";
import ModalTheme from "@/components/ui/ModalTheme";

export default {
    props: ["existingSsoSystem"],
    data() {
        return {
            /**
             * @type SsoSystem
             */
            ssoSystem: null,
            isSsoSystemNew: false,
            availableTypes: SSO_SYSTEM_TYPES,
            newDomain: null,
            validationErrors: []
        };
    },
    components: {
        ModalTheme
    },
    created() {
        if (null === this.existingSsoSystem) {
            this.createNewSsoSystem();
        } else {
            this.ssoSystem = this.existingSsoSystem;
        }
    },
    methods: {
        closeModal() {
            this.ssoSystem = null;
            this.$emit("modalClosed");
        },
        async save() {
            try {
                if (this.isSsoSystemNew) {
                    await SsoSystemHttpService.createSsoSystem(this.ssoSystem);
                } else {
                    await SsoSystemHttpService.updateSsoSystem(this.ssoSystem);
                }
                this.closeModal();
            } catch (error) {
                this.$swal({
                    type: "error",
                    title: "An error occurred",
                    text: error.message
                });
            }
        },
        createNewSsoSystem() {
            this.isSsoSystemNew = true;
            this.ssoSystem = new SsoSystem();
        },

        addDomain() {
            if (!this.newDomain) {
                return;
            }
            this.ssoSystem.domains.push({ name: this.newDomain });
            this.newDomain = null;
        },

        removeDomain(domainName) {
            this.ssoSystem.domains = this.ssoSystem.domains.filter(domain => {
                return domainName !== domain.name;
            });
        },

        validateForm(event) {
            event.preventDefault();
            this.validationErrors = [];

            if (this.ssoSystem.domains.length === 0) {
                this.validationErrors.push("Please add at least one domain");
            }

            if (this.validationErrors.length === 0) {
                this.save();
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// SsoSystemFormModal.vue?7df2568e